import { render, staticRenderFns } from "./GiftPage.vue?vue&type=template&id=5f347443&"
import script from "./GiftPage.vue?vue&type=script&lang=js&"
export * from "./GiftPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports